import { Button } from '@mui/material'
import React from 'react'
import { MdHighlightOff } from 'react-icons/md'
import MyResult from '../../components/MyResult'
import { useNavigate } from 'react-router-dom';

export default function Failed({result}) {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate(`/m2d/models/${result.m2dModelId}`);
  };

  const handleBack = () => {
    navigate("/m2d/history");
  };

  return (
    <>
      <MyResult
            status="error"
            title="Process failed"
            subTitle="Please check and modify your files according to the following error message."
            extra={[
              <Button
                variant="contained"
                key="1"
                type="primary"
                onClick={handleBack}
                style={{ marginRight: "10px" }}
              >
                Go back to your account
              </Button>,
              <Button variant="outlined" key="2" type="default" onClick={handleTryAgain}>
                Try again
              </Button>,
            ]}
          />
          <div className="error-desc">
            <div className="error-desc-title">
              The content you submitted has the following error:
            </div>
            <div className="error-desc-error">
              <MdHighlightOff
                style={{
                  fontSize: "18px",
                  marginRight: "10px",
                  color: "rgb(255, 71, 71)",
                }}
              />
              <div className="error-desc-error-text">
                {JSON.parse(result.value).results}
              </div>
            </div>
          </div>
    </>
  )
}
